module.exports = __webpack_public_path__ + "static/media/create.856f1478.svg";